import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Checkbox from './src/checkbox.vue'
import CheckboxButton from './src/checkbox-button.vue'
import CheckboxGroup from './src/checkbox-group.vue'

export const SgCheckbox = withInstall(Checkbox, {
  CheckboxButton,
  CheckboxGroup,
})
export default SgCheckbox

export const SgCheckboxButton = withNoopInstall(CheckboxButton)
export const SgCheckboxGroup = withNoopInstall(CheckboxGroup)

export * from './src/checkbox.type'
